class CbuAccountType {
    constructor(id, value) {
        this.id = id
        this.value = value
    }

    static fromJson({ id, name }) {
        return new CbuAccountType(id, name)
    }
}

export default CbuAccountType
